import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Audiencias.css';
import CountUp from "react-countup";
import { motion } from "framer-motion"; // Importamos Framer Motion

const RrssAudience = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.4 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <section className="audience-rrss-section" ref={sectionRef}>
            <div className='container'>

                {/* Título */}
                <div className="title-container" data-aos="fade-up">
                    <h2 className="title">Audiencia <span>RRSS</span></h2>
                    <div className="title-underline"></div>
                </div>

                {/* Contenido principal */}
                <div className='row m-2'>
                    <div className='col-lg-7'>
                        <div className="section-description pb-0 mb-0" data-aos="fade-up">
                            <p className='pb-0 mb-0'>
                                    Nuestra audiencia en redes sociales mantiene un <span className='description-highlight'>equilibrio sólido entre personas menores y mayores de 
                                    45 años,</span> con una mayor representación de mujeres. Esta diversidad nos permite conectar de manera efectiva 
                                    con distintos segmentos, maximizando los resultados.
                            </p>
                        </div>

                        {/* Barra de progreso animada */}
                        <div data-aos="fade-down">
                            {isVisible && (
                                <div className="progress-wrapper">
                                    <div className="progress-container">
                                        <motion.div
                                            className="progress-bar women"
                                            initial={{ width: 0 }}
                                            animate={{ width: "68%" }}
                                            transition={{ duration: 3, ease: "easeInOut" }}
                                        >
                                            68%
                                        </motion.div>
                                        <motion.div
                                            className="progress-bar men"
                                            initial={{ width: 0 }}
                                            animate={{ width: "32%" }}
                                            transition={{ duration: 3, ease: "easeInOut" }}
                                        >
                                            32%
                                        </motion.div>
                                    </div>
                                    {/* Etiquetas debajo de la barra */}
                                    <div className="progress-labels">
                                        <span className="label women-label">Mujeres</span>
                                        <span className="label men-label">Hombres</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='row text-center audience-stats-container justify-content-center pt-5' data-aos="fade-up">
                            <div className='col-md-5 m-2' data-aos="flip-left" data-aos-delay="200">
                                <div className="audience-circle">
                                    <p>{isVisible && <CountUp start={0} end={28} duration={10} separator="," />}%</p>
                                </div>
                                <div>
                                    <p>personas <span className='underline'>menores</span> a 45 años</p>
                                    <p className='d-none'><span>{isVisible && <CountUp start={0} end={58} duration={10} separator="," />}%</span> Mujeres</p>
                                    <p className='d-none'><span>{isVisible && <CountUp start={0} end={42} duration={10} separator="," />}%</span> Hombres</p>
                                </div>
                            </div>
                            <div className='col-md-5 m-2' data-aos="flip-right" data-aos-delay="300">
                                <div className="audience-circle">
                                    <p>{isVisible && <CountUp start={0} end={72} duration={10} separator="," />}%</p>
                                </div>
                                <div>
                                    <p>personas <span className='underline'>mayores</span> a 45 años</p>
                                    <p className='d-none'><span>{isVisible && <CountUp start={0} end={67} duration={10} separator="," />}%</span> Mujeres</p>
                                    <p className='d-none'><span>{isVisible && <CountUp start={0} end={33} duration={10} separator="," />}%</span> Hombres</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='col-lg-5 text-center'>
                        <img src="assets/audiencia_2_rrss.png" alt="audiencia rrss" className='img-fluid shadow-lg rounded' data-aos="flip-left" />
                    </div>
                </div>

            </div>
        </section>
    );
};

export default RrssAudience;

